import React, { useEffect, useState } from 'react';
import { Section, SectionProps } from '../../components/Section/Section';
import { ContentBlock } from '@jbhi-fi/components/src/ContentBlock';
import { ContentTheme } from '../../transformers/contentfulApiThemeToContentThemeProps';
import { useHomepageProps } from '../../hooks/content/useHomepageProps';
import { RedirectWelcomeAlert } from '../../components/RedirectWelcomeAlert/RedirectWelcomeAlert';
import { HeroBlock, HeroBlockProps } from '@jbhi-fi/components/src/HeroBlock';
import { Disclaimer } from '@jbhi-fi/components/src/Disclaimer';

export type HomeProps = {
  hero?: HeroBlockProps;
  sections: Array<SectionProps>;
  theme?: ContentTheme;
};

export const Home = () => {
  const {
    data: { hero, sections, theme } = { hero: {}, sections: [], theme: {} as ContentTheme },
    isLoading,
    error,
  } = useHomepageProps() || {};
  const [showRedirectedAlert, setShowRedirectedAlert] = useState<boolean>(false);

  useEffect(() => {
    const urlSearchParams = new URL(window.location.href).searchParams;
    if (urlSearchParams.has('redirected')) {
      setShowRedirectedAlert(true);
      urlSearchParams.delete('redirected');
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}${urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : ''}`
      );
    }
  }, []);

  return isLoading || error ? null : (
    <>
      <ContentBlock
        paddingTop={15}
        style={{ backgroundColor: theme?.backgroundColor }}
        paddingBottom={{ mobile: 4, tablet: 15 }}
      >
        <HeroBlock {...hero} />
      </ContentBlock>
      <ContentBlock
        paddingTop={0}
        paddingRight={0}
        paddingLeft={0}
        paddingBottom={{ mobile: 15, tablet: 20 }}
        maxWidth="full"
      >
        {sections?.map((section: SectionProps, i: number) => (
          <Section key={i} {...section} />
        ))}
        <ContentBlock paddingTop={15} paddingBottom={0} paddingX={{ xs: 4, md: 8 }}>
          <Disclaimer disclaimers={window.Jbhifi.disclaimers} />
        </ContentBlock>
      </ContentBlock>
      <RedirectWelcomeAlert
        heading={
          <>
            Exciting news... <em>STACK</em> has moved!
          </>
        }
        content="We’ve moved in with the JB fam to bring you an even bigger and better one-stop hub for the best in home entertainment, latest tech, exclusive competitions, guides, tips, and heaps more. Whether you’re a long time reader or first time caller, we think it’s worth a bookmark."
        isVisible={showRedirectedAlert}
        onClose={() => setShowRedirectedAlert(false)}
      />
    </>
  );
};
